import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Contract } from '@shared/entities/contract';
import { ApiService } from '@shared/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContractService extends ApiService<Contract> {
  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/contracts';
    const detailUrl = '/contracts/{id}';

    super(Contract, masterUrl, detailUrl, 'contracts');
  }

  getContractsBySerialNumber(serialNumber: string): Observable<Contract[]> {
    this.setUrlParameter('serialNumber', serialNumber);
    const { locationId } = this.activatedRoute.snapshot.queryParams;
    if (locationId) {
      this.setUrlParameter('locationId', locationId);
    }
    return this.findAll();
  }
}
